import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { UserService } from '../../../../auth/user/user.service';
import { DmsId } from '../../../customer/model/customer-information.model';
import { DmsIdComponent } from './dms-id.component';

@Component({
  selector: 'cdf-dms-id-container',
  imports: [DmsIdComponent],
  template: `<cdf-dms-id [dmsIds]="dmsIds()" [ownDpno]="ownDpno()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DmsIdContainer {
  readonly userService = inject(UserService);

  readonly dmsIds = input<DmsId[]>();

  readonly ownDpno = computed(() => {
    return this.userService.userSignal()?.distributionPartnerNumber;
  });
}
